import type React from "react";
import { Button } from "../../../../components/ui/button";
import MemedLogo from "../../../../assets/svgs/common/solo-logo.svg";

interface AppProps {
	buttonName?: string;
	onClickFunction?: () => void;
	children?: React.ReactNode;
	hiddenbutton?: boolean;
}

const NavHomeDashboardAdminPartial: React.FunctionComponent<AppProps> = ({buttonName, onClickFunction, hiddenbutton,children}) => {
	return (
		<div className="flex justify-between items-center w-full">
			<div className="flex items-center gap-1">
				<div className="font-semibold text-3xl flex gap-2 items-center justify-center"><MemedLogo className="md:h-10 h-6"/><span className="pt-4">Dashboard</span></div>
			</div>
			<div className="flex justify-end items-center gap-6 w-full">
				{children}
				{!hiddenbutton && (
				<Button
					onClick={onClickFunction}
					className="flex items-center gap-1 bg-primarybuttonbg px-[38px] py-[28px] border border-border rounded-lg font-semibold text-base text-primarybuttontext tracking-wider"
				>
					<span className="text-2xl">+</span> {buttonName}
				</Button>
				)}
			</div>
		</div>
	);
};

export default NavHomeDashboardAdminPartial;
